













import { Component, Vue, Prop } from "vue-property-decorator";
import { BoxPayGrade, PayStatus } from "@/req/pay";
import boxPay from "./recharge/boxPay.vue";
import gamePay from "./recharge/gamePay.vue";

@Component({
  components: {
    boxPay,
    gamePay,
  },
})
export default class Logout extends Vue {
  public payGrade = [];
  public active = 0; // 初始默认
  public timer: any = null; // 定时器名称
  public tabs = [
    {
      name: "盒子充值",
    },
    {
      name: "游戏充值",
    },
  ];
  public tabArr = ["boxPay", "gamePay"];
  public tabCom = "boxPay";
  // 点击切换
  public tabsSkip(index) {
    this.active = index;
    this.tabCom = this.tabArr[this.active];
  }
  public mounted() {
    this.PayGrade();
    // this.PayStatus();
  }
  // 充值校验
  public async PayStatus(val) {
    // const obj = {
    //   token: this.$fn.cookies.getToken("token"),
    //   pay_order: "PF_20200810151114VETsoU13",
    // };
    // const res = await PayStatus(obj);
    // console.log(res);
    // this.timer = setTimeout(() => {
    //   console.log(this.timer)
    //   this.PayStatus();
    // }, 1000);
  }
  // 充值档位
  public async PayGrade() {
    const obj = {
      token: this.$fn.cookies.getToken("token"),
    };
    const res = await BoxPayGrade(obj);
    this.payGrade = res.data.pay_grade;
  }
}
